import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/student-insurances', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const failedInsurance = (Options = {}) => {
  return httpClient
    .get('/api/student-insurances/failed', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const insuranceExcel = (data = {}) => {
  return httpClient
    .post('/api/student-insurances/excel', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const acknowledgeInsurance = (id, data) => {
  return httpClient
    .put(`/api/student-insurances/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const convertToInsurance = (id, data) => {
  return httpClient
    .put(`/api/student-insurances/${id}/converted`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const formViewModel = (Options = {}) => {
  return httpClient
    .get('/api/student-insurances/form-view-models', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  failedInsurance,
  insuranceExcel,
  acknowledgeInsurance,
  convertToInsurance,
  formViewModel
}
